import React, { useEffect, useState } from "react";
import { api } from "@/auth/AuthContext";
import { Card } from "@/components/ui-kit";
import { toast } from "sonner";
import { Gift, Copy, ShareNetwork } from "@phosphor-icons/react";

export const ReferralCard = ({ lang }) => {
  const cs = lang === "cs";
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/referral/me").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(data.link);
      toast.success(cs ? "Odkaz zkopírován" : "Link copied");
    } catch {
      toast.error(cs ? "Kopírování selhalo" : "Copy failed");
    }
  };

  const share = () => {
    if (navigator.share) {
      navigator.share({
        title: "TradeMind AI",
        text: cs ? "Vyzkoušej TradeMind AI — AI asistent pro tradery. Registrace zdarma:" : "Try TradeMind AI — AI assistant for traders. Free signup:",
        url: data.link,
      }).catch(() => {});
    } else copy();
  };

  return (
    <Card className="p-6 space-y-4" data-testid="referral-card">
      <div className="flex items-center gap-2">
        <Gift weight="bold" size={18} className="text-amber-400" />
        <h3 className="text-lg font-medium text-zinc-100">{cs ? "Doporuč a získej měsíc zdarma" : "Refer & earn a free month"}</h3>
      </div>
      <p className="text-sm text-zinc-400">
        {cs
          ? "Sdílej svůj odkaz. Když se přes něj někdo zaregistruje a zaplatí první měsíc PREMIUM nebo ELITE, získáš kredit 499 Kč (1 měsíc PREMIUM) na své předplatné."
          : "Share your link. When someone signs up through it and pays their first PREMIUM or ELITE month, you earn a 499 CZK credit (1 month of PREMIUM) toward your subscription."}
      </p>
      <div className="flex items-center gap-2">
        <div data-testid="referral-link" className="flex-1 bg-zinc-900 border border-zinc-800 rounded-md px-3 py-2 font-mono text-sm text-amber-400 truncate">
          {data.link}
        </div>
        <button onClick={copy} data-testid="referral-copy-btn" className="p-2.5 rounded-md bg-zinc-900 border border-zinc-800 text-zinc-300 hover:text-amber-400 transition-colors" title={cs ? "Kopírovat" : "Copy"}>
          <Copy weight="bold" size={16} />
        </button>
        <button onClick={share} data-testid="referral-share-btn" className="p-2.5 rounded-md bg-zinc-900 border border-zinc-800 text-zinc-300 hover:text-amber-400 transition-colors" title={cs ? "Sdílet" : "Share"}>
          <ShareNetwork weight="bold" size={16} />
        </button>
      </div>
      <div className="grid grid-cols-3 gap-3 text-center" data-testid="referral-stats">
        <div className="bg-zinc-900/60 rounded-md p-3">
          <div className="text-xl font-mono text-zinc-100">{data.referred_count}</div>
          <div className="text-[11px] font-mono uppercase tracking-wider text-zinc-500 mt-1">{cs ? "Pozvaní" : "Referred"}</div>
        </div>
        <div className="bg-zinc-900/60 rounded-md p-3">
          <div className="text-xl font-mono text-green-400">{data.credit_applied_czk} Kč</div>
          <div className="text-[11px] font-mono uppercase tracking-wider text-zinc-500 mt-1">{cs ? "Připsáno" : "Credited"}</div>
        </div>
        <div className="bg-zinc-900/60 rounded-md p-3">
          <div className="text-xl font-mono text-amber-400">{data.credit_pending_czk} Kč</div>
          <div className="text-[11px] font-mono uppercase tracking-wider text-zinc-500 mt-1">{cs ? "Čeká" : "Pending"}</div>
        </div>
      </div>
      {data.credit_pending_czk > 0 && (
        <p className="text-xs text-amber-400/80">
          {cs ? "Čekající kredit se připíše, jakmile budeš mít aktivní předplatné." : "Pending credit is applied once you have an active subscription."}
        </p>
      )}
    </Card>
  );
};
